import { render, staticRenderFns } from "./SettingIcon.vue?vue&type=template&id=e225207c&scoped=true"
import script from "./SettingIcon.vue?vue&type=script&lang=js"
export * from "./SettingIcon.vue?vue&type=script&lang=js"
import style0 from "./SettingIcon.vue?vue&type=style&index=0&id=e225207c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e225207c",
  null
  
)

export default component.exports